












































































import Vue, { PropOptions } from 'vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { mapGetters } from 'vuex';
import { cloneDeep, set } from 'lodash';
import * as Product from '@/core/utils/products';

interface Props {
  lesson: PropOptions;
}
export default Vue.extend({
  name: 'ProductLessonScheduleModal',
  components: { ValidationObserver, ValidationProvider },
  data() {
    return {
      selectedSchedule: '',
      numberOfDays: null,
      date: null,
      formError: null,
    };
  },
  props: {
    lesson: {
      type: Object as () => LessonResponse,
      required: true,
    },
  } as Props,
  mounted() {
    this.selectedSchedule = this.lesson.lesson_start_type;
    this.date = this.lesson.lessons_start_after_date;
    this.numberOfDays = this.lesson.lesson_start_after_days;
  },
  computed: {
    ...mapGetters({
      productForm: 'product/productForm',
    }),
    isFirst(): boolean {
      return this.productForm.lessons.indexOf(this.lesson) === 0;
    },
    showDaysInput(): boolean {
      return this.selectedSchedule === 'after_specific_days';
    },
    showDateInput(): boolean {
      return this.selectedSchedule === 'after_specific_date';
    },
    Product() {
      return Product;
    },
  },
  watch: {
    selectedSchedule: {
      handler(value: string) {
        if (value !== this.lesson.lesson_start_type) {
          this.numberOfDays = null;
          this.date = null;
        }
      },
    },
  },
  methods: {
    async submit(): Promise<void> {
      try {
        // const result = (await this.$store.dispatch(
        //   'product/updateProductLesson',
        //   {
        //     ...this.lesson,
        //     lesson_start_type: this.selectedSchedule,
        //     lesson_start_after_days: parseInt(this.numberOfDays ?? '1'),
        //     lessons_start_after_date: this.date,
        //   }
        // )) as LessonResponse;

        const result = {
          ...this.lesson,
          lesson_start_type: this.selectedSchedule,
          lesson_start_after_days: parseInt(this.numberOfDays ?? '1'),
          lessons_start_after_date: this.date,
          isDirty: true,
        } as LessonResponse;

        const lessons = cloneDeep(this.productForm.lessons) as LessonResponse[];
        const index = lessons.findIndex(x => x.id === result.id);
        lessons[index] = result;

        this.$store.dispatch('product/setProductForm', {
          lessons: lessons,
        });
        this.$emit('close');
      } catch (err) {
        this.selectedSchedule = this.lesson.lesson_start_type;
        this.date = this.lesson.lessons_start_after_date;
        this.numberOfDays = this.lesson.lessons_start_after_days;
        this.formError = err;
      }
    },
  },
});
